/* ALBEUX REVIEWS SLIDESHOW (2 Nov 2026, Copy of Futuristic).
   Turns the list of reviews in the .albeux-reviews block into a slideshow: one review at a time, changing by itself every 6.5 seconds,
   with swipe / scroll, and a row of hairline segments + counter to jump (assets/albeux-reviews-slider.css has the looks).
   - 2 or more visible reviews: slideshow (automatic) and swipe. One review: it sits in the very same place and layout (centred in the slideshow spot); there is nothing to slide to, so no segments (class alb-rv-manual).
   - Waits for Judge.me to draw its reviews (and re-does itself when it draws more, or when "load more" adds some).
   - Pauses on mouse over, touch, keyboard focus, when the block is off screen, and when the tab is hidden.
   - With "reduce motion" on, it never changes by itself (you can still swipe or press the segments).
   - Works on pages slid in from a collection (runs again on shopify:section:load).
   To switch it off: delete the albeux-reviews-slider line in snippets/view-transition-opt-in.liquid. */
(function () {
  'use strict';
  if (window.__albRvSlider) return;
  window.__albRvSlider = true;

  var MS = 6500;
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function visibleRevs(track) {
    var out = [];
    for (var i = 0; i < track.children.length; i++) {
      var el = track.children[i];
      if (!el.classList.contains('jdgm-rev') || el.hasAttribute('data-albeux-hidden')) continue;
      out.push(el);
    }
    return out;
  }

  function unbuild(root) {
    var s = root.__rv;
    if (!s) return;
    root.__rv = null;
    clearTimeout(s.timer);
    clearTimeout(s.scrollT);
    clearTimeout(s.touchT);
    try { s.io.disconnect(); } catch (e) {}
    s.track.removeEventListener('scroll', s.onScroll);
    s.track.removeEventListener('pointerenter', s.onEnter);
    s.track.removeEventListener('pointerleave', s.onLeave);
    s.track.removeEventListener('touchstart', s.onTouch, { passive: true });
    s.track.removeEventListener('touchend', s.onTouchEnd);
    document.removeEventListener('visibilitychange', s.onVis);
    try { s.ctrl.remove(); } catch (e) {}
    s.track.classList.remove('alb-rv-track');
    root.classList.remove('alb-rv-on', 'alb-rv-manual');
  }

  function build(root) {
    var first = root.querySelector('.jdgm-rev');
    if (!first || !first.parentElement) { unbuild(root); return; }
    var track = first.parentElement;
    var revs = visibleRevs(track);
    var old = root.__rv;
    if (revs.length < 1) { unbuild(root); return; }
    if (old && old.track === track && old.n === revs.length && old.ctrl.isConnected) return;
    unbuild(root);

    var s = { track: track, n: revs.length, idx: 0, timer: 0, scrollT: 0, touchT: 0, hover: false, touch: false, focus: false, inView: false, manual: revs.length < 2 };
    root.__rv = s;
    root.style.setProperty('--alb-rv-ms', MS + 'ms');
    track.classList.add('alb-rv-track');
    root.classList.add('alb-rv-on');
    if (s.manual) root.classList.add('alb-rv-manual');

    var ctrl = document.createElement('div');
    ctrl.className = 'alb-rv-ctrl';
    ctrl.setAttribute('role', 'group');
    ctrl.setAttribute('aria-label', 'Review navigation');
    var segs = [];
    for (var i = 0; i < s.n; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'alb-rv-seg';
      b.setAttribute('aria-label', 'Show review ' + (i + 1) + ' of ' + s.n);
      b.setAttribute('data-i', String(i));
      ctrl.appendChild(b);
      segs.push(b);
    }
    var count = document.createElement('span');
    count.className = 'alb-rv-count';
    count.setAttribute('aria-hidden', 'true');
    ctrl.appendChild(count);
    track.parentNode.insertBefore(ctrl, track.nextSibling);
    s.ctrl = ctrl;

    function paused() { return reduce || s.manual || s.hover || s.touch || s.focus || !s.inView || document.hidden; }

    function mark() {
      for (var k = 0; k < segs.length; k++) {
        segs[k].classList.toggle('is-done', k < s.idx);
        segs[k].classList.remove('is-on');
      }
      void ctrl.offsetWidth;
      segs[s.idx].classList.add('is-on');
      count.textContent = pad(s.idx + 1) + ' / ' + pad(s.n);
      ctrl.classList.toggle('is-still', reduce);
    }

    function play() {
      clearTimeout(s.timer);
      if (!track.isConnected) { unbuild(root); return; }
      if (paused()) { ctrl.classList.add('is-paused'); return; }
      ctrl.classList.remove('is-paused');
      mark();
      s.timer = setTimeout(function () { go(s.idx + 1, false); }, MS);
    }

    function go(i, user) {
      s.idx = ((i % s.n) + s.n) % s.n;
      var left = s.idx * track.clientWidth;
      try { track.scrollTo({ left: left, behavior: reduce || s.idx === 0 && !user ? 'auto' : 'smooth' }); } catch (e) { track.scrollLeft = left; }
      mark();
      play();
    }

    ctrl.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.alb-rv-seg');
      if (b) go(parseInt(b.getAttribute('data-i'), 10) || 0, true);
    });
    ctrl.addEventListener('focusin', function () { s.focus = true; play(); });
    ctrl.addEventListener('focusout', function () { s.focus = false; play(); });

    s.onScroll = function () {
      clearTimeout(s.scrollT);
      s.scrollT = setTimeout(function () {
        var w = track.clientWidth || 1;
        var i = Math.max(0, Math.min(s.n - 1, Math.round(track.scrollLeft / w)));
        if (i !== s.idx) { s.idx = i; mark(); play(); }
      }, 140);
    };
    s.onEnter = function (e) { if (e.pointerType === 'mouse') { s.hover = true; play(); } };
    s.onLeave = function (e) { if (e.pointerType === 'mouse') { s.hover = false; play(); } };
    s.onTouch = function () { s.touch = true; clearTimeout(s.touchT); play(); };
    s.onTouchEnd = function () { clearTimeout(s.touchT); s.touchT = setTimeout(function () { s.touch = false; play(); }, 3000); };
    s.onVis = function () { play(); };
    track.addEventListener('scroll', s.onScroll, { passive: true });
    track.addEventListener('pointerenter', s.onEnter);
    track.addEventListener('pointerleave', s.onLeave);
    track.addEventListener('touchstart', s.onTouch, { passive: true });
    track.addEventListener('touchend', s.onTouchEnd);
    document.addEventListener('visibilitychange', s.onVis);

    s.io = new IntersectionObserver(function (es) {
      s.inView = es[0].isIntersecting;
      play();
    }, { threshold: 0.35 });
    s.io.observe(track);
    mark();
  }

  function init() {
    var roots = document.querySelectorAll('.albeux-reviews');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (!root.__rvWatch) {
        root.__rvWatch = true;
        (function (r) {
          var t = 0;
          var run = function () { clearTimeout(t); t = setTimeout(function () { try { build(r); } catch (e) {} }, 350); };
          if ('MutationObserver' in window) {
            new MutationObserver(run).observe(r, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-albeux-hidden'] });
          }
          run();
        })(root);
      }
    }
  }

  if (!('IntersectionObserver' in window)) return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 200); setTimeout(init, 1500); });
  setTimeout(init, 2000);
  setTimeout(init, 5000);
})();